/**
 * @flow
 * @relayHash 39028019c513dc493d1997aeb53168b5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountsNavDrawer_account$ref = any;
export type AccountsNavDrawerQueryVariables = {|
  accountID: string
|};
export type AccountsNavDrawerQueryResponse = {|
  +account: ?{|
    +$fragmentRefs: AccountsNavDrawer_account$ref
  |}
|};
export type AccountsNavDrawerQuery = {|
  variables: AccountsNavDrawerQueryVariables,
  response: AccountsNavDrawerQueryResponse,
|};
*/


/*
query AccountsNavDrawerQuery(
  $accountID: ID!
) {
  account(id: $accountID) {
    ...AccountsNavDrawer_account
    id
  }
}

fragment AccountsNavDrawer_account on Account {
  first_name
  last_name
  org {
    id
    name
  }
  authorizedApps {
    name
    access
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "accountID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "accountID"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AccountsNavDrawerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "account",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AccountsNavDrawer_account",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AccountsNavDrawerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "account",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Account",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "first_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "last_name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "org",
            "storageKey": null,
            "args": null,
            "concreteType": "Org",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "authorizedApps",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthorizedApp",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "access",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "AccountsNavDrawerQuery",
    "id": null,
    "text": "query AccountsNavDrawerQuery(\n  $accountID: ID!\n) {\n  account(id: $accountID) {\n    ...AccountsNavDrawer_account\n    id\n  }\n}\n\nfragment AccountsNavDrawer_account on Account {\n  first_name\n  last_name\n  org {\n    id\n    name\n  }\n  authorizedApps {\n    name\n    access\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9fdddde66bd8c06d88b1aff14ec25bc6';
module.exports = node;
